import { ButtonBase, useTheme } from "@mui/material";

import cx from 'classnames';
import { useTranslation } from "react-i18next";
import { tokens } from "../../../../../theme";

export const CartDropdownComponent = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    return (
        <ButtonBase
            key={props.key}
            onClick={props.onClick}
            className={cx('',{
                'active': props.isSelected
            })}
            sx={{
                flexShrink:0,
                height:32,
                minWidth:300,
                width:1,
                pl:1.5,
                pr:0.5,
                textAlign:"left",
                display:"flex",
                justifyContent:'space-between',
                alignItems:"center",
                borderRadius:2,
                '&.active' : {
                    background: theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100],
                    color: theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400],
                    fontWeight:"900",
                }
            }}
        >
            <span>
                {props.option.barcode}
            </span>
        </ButtonBase>
    )
}